import { render, staticRenderFns } from "./TeacherDetails.vue?vue&type=template&id=d3a783d4&"
import script from "./TeacherDetails.vue?vue&type=script&lang=js&"
export * from "./TeacherDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports